import React from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { appWrapperProperties } from './appWrapperProperties.ts';

export function wrap<P extends object>(Component: React.ComponentType<P>) {
  const WrappedComponent = (props: P) => {
    const allProps = {
      ...props,
      ...appWrapperProperties,
      location: useLocation(),
      navigate: useNavigate(),
      useRoutes: useRoutes,
    };

    return <Component {...allProps} />;
  };

  // Name it for debugging (not required but nice)
  WrappedComponent.displayName = `Wrapped(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
}
